import React, { Component } from 'react';
import { View, Text, TouchableOpacity, Vibration, Image, TouchableWithoutFeedback } from 'react-native';
import { toJS } from 'mobx';
import { DeviceInfo } from 'qunar-react-native';
import { Icon as QIcon } from '@qnpm/q-theme';
import { Label } from '@qnpm/q-components';
import { Card } from '@qnpm/q-design-card';
import { Colors } from '@qnpm/q-theme';
import { inject, observer } from 'mobx-react/native';
import Swipeout from '../../Swipeout';
import Icon from '../../Icon';
import CURRENCYMAP from '../../../Constant/currencyMap';
import uitls from '../businessComps/utils';
import styles from './style';
import { DEVICE_WIDTH } from '../../../Constant/size';
import PPLogUtil, { OPER_CLICK } from '../../../Utils/PPLogUtil';
import ServiceProgress from './serviceProgress';
import RootStore from '../../../Store/SearchResult';
import ServiceBtns from './serviceBtns';
import Cashback from './cashback';
import ButtonContainer from "./ButtonContainerComp/index";
import MemberCard from '../../MemberCard';
import PriceBubble from '../PriceBubble';

const { isMini } = DeviceInfo;

const { scenes: {baseColor} } = Colors;

const maxActionTitleWidth = (DEVICE_WIDTH - 84) / 4;

const ACTION_NAME_DELETE = 'order_delete';

const needCutChar = (str: string) => {
    for (let i = str.length; i > 0; i--) {
        if (i * 13 + 2 <= maxActionTitleWidth) {
            return i;
        }
    }
    return 0;
};
interface DealInfoModel {
    businessType?: string;
    sysCode: number;
    orderNo: string;
    canDelete: boolean;
    isShare: boolean;
    deleteTip: string;
}
interface Props {
    enableDelete: boolean;
    data: any;
    children: React.ReactElement;
    sourceFrom:string;
    orderCellIndex: any;
    serviceBtnList: any[];
    index: number;
    abSlotId: string;
    dataType:any;
    mergeIndex:any;
    getClose(openedSwipe: any, closeSwipe: any): void;
    onBeginSwipe(curSwipe: any): void;
    onSwipeScroll(scrollEnabled: boolean): void;
    onOrderBtnPress(action: ActionModel, businessType: string, index: number, sysCode: any, orderNo: any, orderCellIndex: any, isPrivate: boolean): void;
    onOrderItemPress(params: any, businessType: string, sysCode: any, orderNo: any, orderCellIndex: any, isPrivate: boolean): void;
    onOrderDeletePress(info: DealInfoModel): void;
    onRefresh: any;
}

@inject((stores:RootStore)=>({
    serviceBtnList: stores.orderlist.serviceBtnList,
    abSlotId: stores.orderlist.abSlotId,
}))
@observer
class ItemWrapper extends Component<Props> {
    componentDidMount(){
        const { bubbleImage, bigBubbleImage, businessType } = this.props.data || {};
        if(bubbleImage || bigBubbleImage){
            PPLogUtil.priceBubbleBtn('show','priceBubble',{
                businessType
            });
        }
    }
    // 订单按钮点击
    public _onOrderBtnPress = (action: ActionModel, index: number) => {
        // 特殊处理删除按钮
        if (action?.actionName === ACTION_NAME_DELETE) {
            this._onOrderDeletePress();
        }
        // TODO 跳转详情页，切换check选中态，
        const { onOrderBtnPress, data: { businessType, sysCode, orderNo, private:isPrivate} = {},orderCellIndex } = this.props;
        // TODO 校验当前单是否处于删除状态中 checkOrderInDeleting(data.orderNo)
        if(onOrderBtnPress){
            onOrderBtnPress(action, businessType, index,sysCode, orderNo, orderCellIndex, isPrivate);
        }
        PPLogUtil.orderButtonClickOrShowLog(action.title, OPER_CLICK, sysCode, orderNo, businessType, this.props.sourceFrom, (index + 1).toString(), action);
    };

    // 订单点击
    public _onOrderItemPress = () => {
        // TODO 跳转详情页，切换check选中态，
        const { onOrderItemPress, data: { appAction, businessType, sysCode, orderNo, private:isPrivate} = {},orderCellIndex } = this.props;
        // TODO 校验当前单是否处于删除状态中 checkOrderInDeleting(data.orderNo)
        if(onOrderItemPress){
            onOrderItemPress(uitls.getDetailSchema(appAction), businessType,sysCode, orderNo,orderCellIndex, isPrivate);
        }
        PPLogUtil.orderCardShowOrClickLog(OPER_CLICK, sysCode, orderNo, businessType, this.props.sourceFrom, (orderCellIndex + 1).toString());

        if (isPrivate) {
            PPLogUtil.privateOrderCardShowOrClick(true);
        }
    };

    // 订单删除
    public _onOrderDeletePress = () => {
        const { onOrderDeletePress, enableDelete, data, } = this.props;

        if (!enableDelete) {
            return;
        }
        // 小程序端暂不支持
        if(!isMini){
            Vibration.vibrate(500);
        }

        const { sysCode, orderNo, canDelete, isShare, deleteTip } = data;
        const delInfo = {
            sysCode,
            orderNo,
            canDelete,
            isShare,
            deleteTip: deleteTip || '抱歉！为了不影响您的正常使用，此订单不可删除'
        };
        if (onOrderDeletePress) {
            onOrderDeletePress(delInfo);
        }
    };
    public priceBubblePress = () => {
        const { bubbleJumpUrl, bigBubbleJumpUrl, businessType } = this.props.data || {};
        if(!bubbleJumpUrl && !bigBubbleJumpUrl)return;
        let url = bigBubbleJumpUrl||bubbleJumpUrl||'';
        if((url.indexOf('qunaraphone') === -1) && (url.indexOf('qunariphone') === -1)){
            url = `${DeviceInfo.scheme}${url}`;
        }
        Ext.Router.Bridge.sendScheme({ url }, () => null);
        PPLogUtil.priceBubbleBtn('click','priceBubble',{
            businessType
        });
    }
    public render() {
        const {
            enableDelete,
            data = {},
            children,
            serviceBtnList,
            getClose,
            onBeginSwipe,
            onSwipeScroll,
            orderCellIndex,
            index,
            abSlotId,
            dataType,
            mergeIndex
        } = this.props;
        //console.log(data);
        // if (index === 2) {
        //     data.extData = {
        //         "sysCode": 2801,
        //         "orderNo": "xep200518133011122",
        //         "serviceProgress": [
        //           {
        //             "changeTime": "2020-06-14 14:36:16",
        //             "redPoint": true,
        //             "module": "gongdan",
        //             "moduleName": "人工服务进度1",
        //             "url": "https://m.flight.qunar.com/h5/flight/fwpview/ext/serviceProgress?orderNo=332060917094",
        //             "desc": "小驼已处理完您的问题，点击查看处理结果",
        //             "shortChangeTime": "06-14 14:36"
        //           },
        //         ]};
        //     }

        if (abSlotId !== 'B' && !DeviceInfo.isNotRn) {
            return this.renderOld();
        }

        const {
            // 左上角图片
            iconfont,
            // 左上角图片颜色
            iconColor,
            // header部分的业务线标题
            title,
            // 订单状态字段
            statusDesc,
            // header右侧一般是订单状态，当showRightArrow为true时，展示右箭头
            showRightArrow,
            // 订单状态，不同状态的订单，右上角的字的颜色不一样
            _orderStatus = 'isNormal',
            // header标题后面的小icons们
            icon=[],
            // 存在截止日志的订单会在头部之下，body之上展示一个黄条，提示赶快去干什么什么事
            deadlineNotice,
            // 是否需要订单body左侧展示一个check按钮
            isBindView,
            // 格式化后的价格
            fixPrice,
            // 价格浮标
            bubbleImage='',
            // 大尺寸价格浮标
            bigBubbleImage='',//='https://s.qunarzz.com/f_cms/2022/1660098179971_728401508.png',
            // 价格浮标文案
            bubbleText='',
            // 浮标跳转
            // bubbleJumpUrl='',
            // 支付积分
            payPoint,
            // 货币符号
            currency,
            // 转换价格
            convertPrice,
            // 转换的价格
            fixConvertPrice,
            // 是否有共享订单，是的话会在下面展示一个黄条，提示你有来自谁谁谁的订单
            isShare,
            // 订单按钮数据
            actionInfos,
            // 传入此字段，价格区域，这个组件来完成
            isCommonPriceTpl = true,
            _disable,
            canDelete,
            extData =  {},
            orderNo,
            tryToSleepOrder,
            showPrivilegeData,
            bindPrivilegeData
        } = data;
        // 是否展示删除订单按钮
        // TODO: 小程序删除订单登录态校验不通过，下掉
        if (enableDelete && canDelete && !isMini) {
           const res = actionInfos.find(item=>(item.actionName === ACTION_NAME_DELETE));
           if (!res) {
               actionInfos.push({
                   title: '删除订单',
                   actionName: ACTION_NAME_DELETE,
                })
           }
        }
        // 异步接口 - 按钮数据
        const async_res = serviceBtnList.find(item => {
            return orderNo === item?.orderNo;
        })
        const app_action = async_res && uitls.buildActionInfos(async_res.appAction)||[];
        // 与同步接口合并-去重
        const async_actionInfos = app_action.length>0 ?uitls.jsonArrayUnique(actionInfos.concat([...app_action]).slice(),'actionName') : actionInfos;
        const mergeFirst = (dataType ==='merge' && (mergeIndex === 0));
        const mergeCon = (dataType ==='merge' && (mergeIndex >= 1));
        const statusDescDom = (
            <View style={styles.orderHeaderRightWrapper} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_STATUS)}>
                {showRightArrow ? (
                    <Text
                        style={[
                            styles.orderHeaderRight,
                            styles.orderHeaderRightArrow,
                            _disable ? { color: baseColor.disableText } : null
                        ]}
                    >
                        <Icon code={statusDesc} />
                    </Text>
                ) : (
                    <Text
                        style={[
                            styles.orderHeaderRight,
                            {
                                color:
                                    _orderStatus === 'isNormal'
                                        ? baseColor.text1
                                        : _orderStatus === 'isWarning'
                                        ?  baseColor.price
                                        : baseColor.disableText
                            },
                            _disable ? { color: baseColor.disableText } : null
                        ]}
                        numberOfLines={1}
                    >
                        {statusDesc}
                    </Text>
                )}
            </View>
        );
        const OrderItem = (
            <Card radius={'medium'} backgroundColor={baseColor.white} accessible={false}>
                <TouchableOpacity
                    activeOpacity={1}
                    onPress={this._onOrderItemPress}
                    accessible={false}
                >
                    {
                        !mergeCon && (
                            <View style={[styles.orderHeader, isBindView ? { paddingLeft: 46 } : null]}>
                                <View style={styles.orderHeaderLeft}>
                                    <View
                                        style={[
                                            styles.orderIconWrapper,
                                            iconColor ? { backgroundColor: iconColor } : null,
                                            _disable ? { backgroundColor: baseColor.disableBtn } : null
                                        ]}
                                    >
                                        <Icon code={iconfont} style={styles.orderIcon} />
                                    </View>
                                    <View style={styles.orderTitleWrapper}>
                                        <Text
                                            style={[styles.orderTitle, _disable ? { color: baseColor.disableText } : null]}
                                            numberOfLines={1}
                                            {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_CARD_TITLE)}
                                        >
                                            {title}
                                        </Text>
                                        {
                                            Boolean(tryToSleepOrder) &&
                                            <View style={[styles.sleepLabel, {
                                                borderColor: _disable ? baseColor.disableText : '#FF6600'
                                            }]}> 
                                                <Text style={[styles.sleepLabelText, {
                                                    color: _disable ? baseColor.disableText : '#FF6600'
                                                }]}>试睡</Text>
                                            </View>
                                        }
                                        {Boolean(icon) &&
                                            icon.map((item: { title: string },index:number) => (
                                                <View style={styles.labelWrap} key={index}>
                                                    <Label text={item.title} needScale type={"border"} />
                                                </View>
                                            ))}
                                    </View>
                                </View>
                                { !mergeFirst && statusDescDom }
                            </View>
                        )
                    }
                    {Boolean(deadlineNotice) && (
                        <View style={styles.orderDeadlineWrapper}>
                            <Icon
                                code="&#xe6e7;"
                                style={[styles.orderDeadlineIcon, _disable && { color: baseColor.disableText }]}
                            />
                            <Text
                                numberOfLines={1}
                                style={[styles.onrderDeadlineText, _disable && { color: baseColor.disableText }]}
                            >
                                {deadlineNotice}
                            </Text>
                        </View>
                    )}
                </TouchableOpacity>
                    <TouchableOpacity
                        activeOpacity={1}
                        style={styles.orderBody}
                        onPress={this._onOrderItemPress}
                        accessible={false}
                    >
                        {Boolean(isBindView) && (
                            <View style={styles.orderCheckBtnWrapper}>
                                <TouchableOpacity activeOpacity={1} style={styles.orderCheckBtn}>
                                    <Icon code="&#xf078;" style={styles.orderCheckIcon} />
                                </TouchableOpacity>
                            </View>
                        )}
                        <View style={styles.orderBodyContent}>
                        <View style={styles.orderBodyContentInner}>
                                {/* 左侧-内容区 */}
                                {children}
                                {/* 右侧-订单状态、价格 */}
                                <View style={{flexDirection:'column'}}>
                                    {/* 聚合单-订单状态 */}
                                    { dataType ==='merge' && statusDescDom }
                                    { dataType ==='merge' && <View style={{height:24}}></View> }
                                    {/* 价格区域 */}
                                    {isCommonPriceTpl ? (
                                        <View style={styles.orderBodyRight} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_PRICE)}>
                                            {fixPrice ? (
                                                <Text
                                                    style={[
                                                        styles.orderPriceWrapper,
                                                        _disable ? styles.disableColor : null
                                                    ]}
                                                    numberOfLines={1}
                                                >
                                                    <Text style={styles.orderPriceCurrency}>
                                                        {CURRENCYMAP[currency]}
                                                    </Text>
                                                    <Text style={styles.orderPrice}>{fixPrice}</Text>
                                                </Text>
                                            ):null}
                                            {(Boolean(currency !== '&yen;' && convertPrice) && fixPrice) ? (
                                                <Text
                                                    style={[
                                                        styles.orderPriceWrapper,
                                                        _disable ? styles.disableColor : null
                                                    ]}
                                                    numberOfLines={1}
                                                >
                                                    <Text style={[styles.orderPriceConvert]}>
                                                        约合&yen;
                                                        {fixConvertPrice}
                                                    </Text>
                                                </Text>
                                            ):null}
                                            {(payPoint>0) ? (
                                                <Text
                                                    style={[
                                                        styles.orderPriceWrapper,
                                                        _disable ? styles.disableColor : null
                                                    ]}
                                                    numberOfLines={1}
                                                >
                                                    {fixPrice?(
                                                        <Text style={{fontSize: 12,color: '#424242'}}>
                                                            +{payPoint}积分
                                                        </Text>
                                                        ):(
                                                        <Text style={{fontSize: 16}}>
                                                            {payPoint}积分
                                                        </Text>
                                                    )}
                                                </Text>
                                            ):null}
                                            {/* {bubbleImage?(
                                                <TouchableWithoutFeedback 
                                                    hitSlop={{
                                                        left: 5,
                                                        right: 5,
                                                        top: 5,
                                                        bottom: 5
                                                    }}
                                                    style={styles.priceBubble}
                                                    onPress={this.priceBubblePress}
                                                >
                                                    <View style={styles.priceBubbleBox}>
                                                        <Image source={{uri: bubbleImage}} style={styles.priceBubbleImage} />
                                                    </View>
                                                </TouchableWithoutFeedback>
                                               
                                            ):null} */}
                                            <PriceBubble
                                                bubbleImage={bubbleImage}
                                                bubbleText={bubbleText}
                                                bigBubbleImage={bigBubbleImage}
                                                onPress={this.priceBubblePress}
                                            />
                                        </View>
                                    ) : null}
                                </View>
                            </View>

                            {Boolean(isShare) && (
                                <View style={styles.shareTipWrapper}>
                                    <Icon
                                        code="&#xe230;"
                                        style={[styles.shareTipIcon, _disable && { color: baseColor.disableText }]}
                                    />
                                    <Text
                                        style={[styles.shareTipText, _disable && { color: baseColor.disableText }]}
                                    >
                                        该订单由您的好友共享给您
                                    </Text>
                                </View>
                            )}
                        </View>
                    </TouchableOpacity>

                    <ServiceProgress data={data} index={index} haveCashback={!!data?.scanCodeCashbackTip}/>

                    {
                        !!data?.scanCodeCashbackTip && <Cashback data={data} orderCellIndex={orderCellIndex} />
                    }  
                    {
                        Boolean(showPrivilegeData)
                        &&
                        <MemberCard
                            data={showPrivilegeData}                           
                            marketing={bindPrivilegeData}
                            onRefresh={this.props.onRefresh}
                        />
                    }

                    <ServiceBtns data={data} serviceBtnList={serviceBtnList} index={orderCellIndex}/>

                    <ButtonContainer
                        data={data}
                        dataType={dataType}
                        buttonInfos={async_actionInfos}
                        onActionPress={(item, index)=>{
                            this._onOrderBtnPress(item, index);
                        }}
                    />
            </Card>
        );
        return (
            <View style={dataType ==='merge' ?  styles.itemMergeWrapper : styles.orderItemWrapper}>
                    {
                        mergeCon && <View style={styles.mergeUpMargin}></View>
                    }
                    {OrderItem}
                    {
                        mergeCon && <View style={styles.mergeUnderline}></View>
                    }
            </View>
        );
    }


    public renderOld() {
        const {
            enableDelete,
            data = {},
            children,
            getClose,
            onBeginSwipe,
            onSwipeScroll,
            index,
            dataType,
            mergeIndex
        } = this.props;

        // if (index === 2) {
        //     data.extData = {
        //         "sysCode": 2801,
        //         "orderNo": "xep200518133011122",
        //         "serviceProgress": [
        //           {
        //             "changeTime": "2020-06-14 14:36:16",
        //             "redPoint": true,
        //             "module": "gongdan",
        //             "moduleName": "人工服务进度1",
        //             "url": "https://m.flight.qunar.com/h5/flight/fwpview/ext/serviceProgress?orderNo=332060917094",
        //             "desc": "小驼已处理完您的问题，点击查看处理结果",
        //             "shortChangeTime": "06-14 14:36"
        //           },
        //         ]};
        //     }


        const {
            // 左上角图片
            iconfont,
            // 左上角图片颜色
            iconColor,
            // header部分的业务线标题
            title,
            // 订单状态字段
            statusDesc,
            // header右侧一般是订单状态，当showRightArrow为true时，展示右箭头
            showRightArrow,
            // 订单状态，不同状态的订单，右上角的字的颜色不一样
            _orderStatus = 'isNormal',
            // header标题后面的小icons们
            icon=[],
            // 存在截止日志的订单会在头部之下，body之上展示一个黄条，提示赶快去干什么什么事
            deadlineNotice,
            // 是否需要订单body左侧展示一个check按钮
            isBindView,
            // 格式化后的价格
            fixPrice,
            // 价格浮标
            bubbleImage='',
            // 价格浮标文案
            bubbleText = '',
            businessType,
            // 浮标跳转
            bubbleJumpUrl='',
            // 货币符号
            currency,
            // 转换价格
            convertPrice,
            // 转换的价格
            fixConvertPrice,
            // 是否有共享订单，是的话会在下面展示一个黄条，提示你有来自谁谁谁的订单
            isShare,
            // 订单按钮数据
            actionInfos,
            // 传入此字段，价格区域，这个组件来完成
            isCommonPriceTpl = true,
            _disable,
            canDelete,
            extData =  {}
        } = data;
        const mergeFirst = (dataType ==='merge' && (mergeIndex === 0));
        const mergeCon = (dataType ==='merge' && (mergeIndex >= 1));
        const OrderItem = (
            <Card radius={"medium"}  backgroundColor={baseColor.white}>
                <TouchableOpacity  activeOpacity={1} accessible={false}>
                    <View style={[styles.orderHeader, isBindView ? { paddingLeft: 46 } : null]}>
                        <View style={styles.orderHeaderLeft}>
                            <View
                                style={[
                                    styles.orderIconWrapper,
                                    iconColor ? { backgroundColor: iconColor } : null,
                                    _disable ? { backgroundColor: baseColor.disableBtn } : null
                                ]}
                            >
                                <Icon code={iconfont} style={styles.orderIcon} />
                            </View>
                            <View style={styles.orderTitleWrapper}>
                                <Text
                                    style={[styles.orderTitle, _disable ? { color: baseColor.disableText } : null]}
                                    numberOfLines={1}
                                >
                                    {title}
                                </Text>
                                {Boolean(icon) &&
                                    icon.map((item: { title: string },index:number) => (
                                        <View style={styles.labelWrap} key={index}>
                                            <Label text={item.title} needScale type={"border"} />
                                        </View>
                                    ))}
                            </View>
                        </View>
                        <View style={styles.orderHeaderRightWrapper} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_STATUS)}>
                            {showRightArrow ? (
                                <Text
                                    style={[
                                        styles.orderHeaderRight,
                                        styles.orderHeaderRightArrow,
                                        _disable ? { color: baseColor.disableText } : null
                                    ]}
                                >
                                    <Icon code={statusDesc} />
                                </Text>
                            ) : (
                                <Text
                                    style={[
                                        styles.orderHeaderRight,
                                        {
                                            color:
                                                _orderStatus === 'isNormal'
                                                    ? baseColor.brandText
                                                    : _orderStatus === 'isWarning'
                                                    ?  baseColor.price
                                                    : baseColor.disableText
                                        },
                                        _disable ? { color: baseColor.disableText } : null
                                    ]}
                                    numberOfLines={1}
                                >
                                    {statusDesc}
                                </Text>
                            )}
                        </View>
                    </View>
                    {Boolean(deadlineNotice) && (
                        <View style={styles.orderDeadlineWrapper}>
                            <Icon
                                code="&#xe6e7;"
                                style={[styles.orderDeadlineIcon, _disable && { color: baseColor.disableText }]}
                            />
                            <Text
                                numberOfLines={1}
                                style={[styles.onrderDeadlineText, _disable && { color: baseColor.disableText }]}
                            >
                                {deadlineNotice}
                            </Text>
                        </View>
                    )}
                    <TouchableOpacity
                        accessible={false}
                        activeOpacity={1}
                        style={styles.orderBody}
                        onPress={this._onOrderItemPress}
                    >
                        {Boolean(isBindView) && (
                            <View style={styles.orderCheckBtnWrapper}>
                                <TouchableOpacity activeOpacity={1} style={styles.orderCheckBtn}>
                                    <Icon code="&#xf078;" style={styles.orderCheckIcon} />
                                </TouchableOpacity>
                            </View>
                        )}
                        <View style={styles.orderBodyContent} >
                            <View style={styles.orderBodyContentInner}>
                                {children}
                                {/* 价格区域 */}
                                {isCommonPriceTpl && fixPrice ? (
                                    <View style={styles.orderBodyRight}>
                                        <Text
                                            style={[
                                                styles.orderPriceWrapper,
                                                _disable ? styles.disableColor : null
                                            ]}
                                            numberOfLines={1}
                                            {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_PRICE)}
                                        >
                                            <Text style={styles.orderPriceCurrency}>
                                                {CURRENCYMAP[currency]}
                                            </Text>
                                            <Text style={styles.orderPrice}>{fixPrice}</Text>
                                        </Text>
                                        {Boolean(currency !== '&yen;' && convertPrice) && (
                                            <Text
                                                style={[
                                                    styles.orderPriceWrapper,
                                                    _disable ? styles.disableColor : null
                                                ]}
                                                numberOfLines={1}
                                                {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_PRICE)}
                                            >
                                                <Text style={[styles.orderPriceConvert]}>
                                                    约合&yen;
                                                    {fixConvertPrice}
                                                </Text>
                                            </Text>
                                        )}
                                        {/* {bubbleImage?(
                                            <TouchableWithoutFeedback 
                                                hitSlop={{
                                                    left: 5,
                                                    right: 5,
                                                    top: 5,
                                                    bottom: 5
                                                }}
                                                style={styles.priceBubble}
                                                onPress={this.priceBubblePress}
                                            >
                                                <View style={styles.priceBubbleBox}>
                                                    <Image source={{uri: bubbleImage}} style={styles.priceBubbleImage} />
                                                </View>
                                            </TouchableWithoutFeedback>
                                        ):null} */}
                                        <PriceBubble
                                                bubbleImage={bubbleImage}
                                                bubbleText={bubbleText}
                                                onPress={this.priceBubblePress}
                                            />
                                    </View>
                                ) : null}
                            </View>
                        {Boolean(isShare) && (
                            <View style={styles.shareTipWrapper}>
                                <Icon
                                    code="&#xe230;"
                                    style={[styles.shareTipIcon, _disable && { color: '#bdbdbd' }]}
                                />
                                <Text
                                    style={[styles.shareTipText, _disable && { color: '#bdbdbd' }]}
                                >
                                    该订单由您的好友共享给您
                                </Text>
                            </View>
                        )}
                    </View>
                </TouchableOpacity>
                <ServiceProgress data={data} index={index}/>
                {/* 如果有按钮的话 */}
                {Boolean(actionInfos?.length) && (
                    <View style={styles.orderFooter}>
                        {actionInfos.map((action: ActionModel, index: number) => {
                            if (!action.title) {
                                return null;
                            }
                            const len = actionInfos.length;
                            const maxLength = needCutChar(action.title);
                            const newTitle =
                                maxLength === action.title.length
                                    ? action.title
                                    : `${action.title.slice(0, maxLength)}…`;
                            return (
                                <TouchableOpacity
                                    activeOpacity={1}
                                    onPress={() => {
                                        this._onOrderBtnPress(action, index);
                                    }}
                                    key={action.actionName}
                                    style={[
                                        styles.orderBtn,
                                        len < 4 ? { width: 'auto', paddingHorizontal: 10 } : null,
                                        !_disable && action.isHighLight ? styles.highlightBtn : null
                                    ]}
                                    {...global.orderAccessibilityLabel(`${global.orderAccessibilityLabelName.CARD_BTN}${index}`)}
                                    >
                                        <Text
                                            style={[
                                                styles.orderBtnText,
                                                !_disable && action.isHighLight
                                                    ? styles.highlightBtnText
                                                    : null
                                            ]}
                                            numberOfLines={1}
                                        >
                                            {len < 4 ? action.title : newTitle}
                                        </Text>
                                    </TouchableOpacity>
                                );
                            })}
                        </View>
                    )}
                </TouchableOpacity>
            </Card>
        );

        return (
            <View style={dataType ==='merge' ?  styles.itemMergeWrapper : styles.orderItemWrapper}>
                {
                    mergeCon && <View style={styles.mergeUpMargin}></View>
                }
                {enableDelete ? (
                    <Swipeout
                        autoClose
                        buttonWidth={90}
                        backgroundColor={canDelete ? '#fc4022' : baseColor.disableText}
                        getClose={getClose}
                        onBeginSwipe={onBeginSwipe}
                        style={{
                            borderRadius: 8,
                            overflow: 'hidden'
                        }}
                        scroll={(scrollEnabled: boolean) => onSwipeScroll?.(scrollEnabled)}
                        right={[
                            {
                                component: (
                                    <View
                                        style={{
                                            flex: 1,
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                        {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_DELETE)}
                                    >
                                        <QIcon
                                            name="delete"
                                            size={24}
                                            color={baseColor.white}
                                        />
                                        <Text
                                            style={{
                                                color: baseColor.white,
                                                backgroundColor: 'transparent'
                                            }}
                                        >
                                            删除
                                        </Text>
                                    </View>
                                ),
                                backgroundColor: 'transparent',
                                onPress: this._onOrderDeletePress
                            }
                        ]}
                    >
                        <TouchableOpacity activeOpacity={1} accessible={false}>{OrderItem}</TouchableOpacity>
                    </Swipeout>
                ) : (
                    OrderItem
                )}
                {
                    mergeCon && <View style={styles.mergeUnderline}></View>
                }
            </View>
        );
    }

}

export default ItemWrapper;

interface ActionModel {
    title: string;
    actionName: string;
    isHighLight: boolean;
}
